import RailsNestedForm from "@stimulus-components/rails-nested-form"

/**
 * Extended Rails Nested Form controller that supports unique index placeholders.
 *
 * This fixes an issue with deeply nested forms where the default "NEW_RECORD" placeholder
 * gets replaced at all levels when adding a parent record, causing child records to share
 * the same index.
 *
 * Usage: Set data-rails-nested-form-index-value to a unique placeholder per nesting level.
 * e.g., "NEW_RECORD_ANSWERS" for answers nested inside questions.
 */
export default class extends RailsNestedForm {
  static values = {
    ...RailsNestedForm.values,
    index: { type: String, default: "NEW_RECORD" }
  }

  add(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(
      new RegExp(this.indexValue, "g"),
      new Date().getTime()
    )

    this.targetTarget.insertAdjacentHTML("beforebegin", content)
  }
}
